import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
	getDMLDefault(context, descricao) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("dMLDefault/access/obter", {DESCRICAO: descricao}).then(({ data }) => {
						resolve(data);
				});
			}
		});
	}, 
};

export default {
	state,
	actions,
	mutations,
	getters
};